var getQuote = function() {
    var containerSelector = '#content';
    var self = this;

    function validateQuoteForm(theForm) {
        var valid = true;

        theForm.find('.has-error').removeClass('has-error').find('.val-error').addClass('hidden');
        var errorsContainer = theForm.find('[data-val-errors-container]');
        errorsContainer.text('');

        // required fields
        var requiredFields = theForm.find('[required]');
        for (var i = 0, len = requiredFields.length; i < len; i++) {
            var $field = $(requiredFields[i]);
            if ($.trim($field.val()) == '') {
                var fieldContainer = $field.closest('.form-group');
                fieldContainer.addClass('has-error');
                fieldContainer.find('[data-val-error-required]').removeClass('hidden');
                valid = false;
            }
        }

        // email validation
        var emails = $('[type="email"]');
        for (var i = 0, len = emails.length; i < len; i++) {
            var $field = $(emails[i]);
            var fieldContainer = $field.closest('.form-group');
            if (!fieldContainer.hasClass('has-error')) {
                if (!validateEmail($field.val())) {
                    fieldContainer.addClass('has-error');
                    fieldContainer.find('[data-val-error-invalid]').removeClass('hidden');
                    valid = false;
                }
            }
        }

        // truck type
        /*if ($('#truckType').val() == '') {
            var fieldContainer = $('#truckType').closest('.form-group');
            fieldContainer.addClass('has-error');
            fieldContainer.find('[data-val-error-required]').removeClass('hidden');
            valid = false;
        }*/

        // coverages checkboxes
        /*var coverages = theForm.find('input[name="coverages[]"]');
        if (coverages.filter(':checked').length == 0) {
            var fieldContainer = coverages.closest('.form-group');
            fieldContainer.addClass('has-error');
            fieldContainer.find('[data-val-error-required]').removeClass('hidden');
            valid = false;
        }*/

        // MC number
        /*if (theForm.find('input[name="icc_authority"]:checked').val() == 'yes') {
            var $field = $('#mcNumber');
            if ($.trim($field.val()) == '') {
                var fieldContainer = $field.closest('.form-group');
                fieldContainer.addClass('has-error');
                fieldContainer.find('[data-val-error-required]').removeClass('hidden');
                valid = false;
            }
        }*/

        if (!valid) {
            var errors = '';
            theForm.find('.val-error').not('.hidden').each(function () {
                errors += ', ' + $(this).text();
            });
            errorsContainer.text(errors.slice(1));
        }

        if(errors == '' || !errors) {
            valid = true;
        }

        return valid;
    }

    function sendQuote(callback) {
        var fieldsValues = {};
        fieldsValues.name = $('[name="name"]').val();
        fieldsValues.address = $('[name="address"]').val();
        fieldsValues.city = $('[name="city"]').val();
        fieldsValues.state = $('[name="state"]').val();
        fieldsValues.zipCode = $('[name="zip_code"]').val();
        fieldsValues.phone = $('[name="phone"]').val();
        fieldsValues.email = $('[name="email"]').val();
        fieldsValues.truckType = $('#truckType').val();
        fieldsValues.equipmentUnit = $('[name="equipment_unit[]"]').map(function() { return this.value; }).get();

        var d1 = {}, d2 = {}, d3 = {};
        $('[name^="drivers[1]"]').each(function () {
            d1[ this.getAttribute("name").slice('drivers[1]['.length, -1) ] = this.value;
        });
        $('[name^="drivers[2]"]').each(function () {
            d2[ this.getAttribute("name").slice('drivers[2]['.length, -1) ] = this.value;
        });
        $('[name^="drivers[3]"]').each(function () {
            d3[ this.getAttribute("name").slice('drivers[3]['.length, -1) ] = this.value;
        });
        fieldsValues.drivers = [ d1, d2, d3 ];

        fieldsValues.limitLiability = $('[name="limit_liability"]').val();
        fieldsValues.cargoInsurance = $('[name="cargo_insurance"]').val();
        fieldsValues.typeOfCargo = $('[name="type_of_cargo"]').val();
        fieldsValues.damageCovarage = $('[name="damage_coverage"]').val();
        fieldsValues.coverages = $('input[name="coverages[]"]:checked').map(function() { return this.value; }).get();
        fieldsValues.iccAuthority = $('[name="icc_authority"]').val();
        fieldsValues.mcNumber = $('#mcNumber').val();
        fieldsValues.additionalInformation = $('[name="additional_information"]').val();

        $.ajax({
            url : ajaxGetQuotePostUrl,
            data: { fieldsValues: fieldsValues },
            type: 'POST',
            dataType: 'json'
        }).done(function (data) {
            if (callback) { callback(); }
            $('[show-on-form-submit]').removeClass('hide');
            $('[hide-on-form-submit]').addClass('hide');
        }).fail(function (data) {
            var errors = data.responseJSON;
            if (errors.error) {
                alertDialogs.alertDialog({ data: { 'msg': errors.error } });
            }
            console.error('Posts could not be loaded.');
        });
    }

    var init = function () {
        self.container = $(containerSelector);

        self.container.on('submit', 'form', function(e) {
            e.preventDefault();
            var form = this;
            if (validateQuoteForm($(this))) {
                sendQuote(function callback() { form.reset(); });
            }
        });
    };

    return {
        init: init
    }
}();

$(function() {
    getQuote.init();
    $(document).on('click', '.send-new-quote-reload', function() {
        $('[show-on-form-submit]').addClass('hide');
        $('[hide-on-form-submit]').removeClass('hide');
    });
});

function validateEmail(email) {
    var emailReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return emailReg.test(email);
}

var alertDialogs = {
    alertDialog : function alertDialog(dataObj) {
        var dialog = new BootstrapDialog({
            title: '',
            message: function(dialog) {
                var message = dialog.getData('msg');
                return $('<div>' + message + '</div>');
            },
            type: BootstrapDialog.TYPE_DEFAULT,
            cssClass: 'alert-dialog',
            closable: true,
            data: dataObj.data || { 'msg': 'message' },
            buttons: [{
                label: 'OK',
                cssClass: 'btn',
                action: function(dialogRef){
                    dialogRef.close();
                }
            }]
        });
        dialog.realize();
        dialog.getModalHeader().hide();
        dialog.open();
    }
};


//////////////////
// WEBPACK FOOTER
// ./resources/themes/pandax/bobtail/old_scripts/get-quote.js
// module id = 539
// module chunks = 0